var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-left mb-3" },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center mb-2" },
        [
          _c("font-awesome-icon", {
            staticClass: "mr-2 icon-chevron",
            attrs: { icon: "chevron-right" },
          }),
          _c("v-label", { staticClass: "label-input" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
        ],
        1
      ),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            transition: "scale-transition",
            "offset-y": "",
            "min-width": "290px",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-text-field",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules,
                              expression: "rules",
                            },
                          ],
                          attrs: {
                            value: _vm.formattedValue,
                            readonly: "",
                            outlined: "",
                            dense: "",
                            name: _vm.name,
                            "data-vv-as": (_vm.label || "")
                              .replace("*", "")
                              .trim(),
                          },
                        },
                        "v-text-field",
                        attrs,
                        false
                      ),
                      on
                    )
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c("v-date-picker", {
            attrs: { type: "date", locale: "es" },
            on: { input: _vm.handleDateSelect },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          }),
        ],
        1
      ),
      _c("span", { staticClass: "red--text" }, [
        _vm._v(_vm._s(_vm.validationErrors.first(_vm.name))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }